import { Grid, Divider, Box } from '@material-ui/core';
import styled from 'styled-components';

export const GridContainer = styled(Grid)`
  min-height: 93vh;
`;

export const ScrollableBox = styled(Box)`
  overflow: scroll;
  overflow-x: hidden;
  padding-bottom: 1vh;
`;

export const StyledDivider = styled(Divider)`
  && {
    background-color: #c2d1d9;
    margin-bottom: 10px;
  }
`;
